import { Injectable, Provider, Type } from '@angular/core';
import { Subject } from 'rxjs';

export function provideGalleryIntl(intl: Type<GalleryIntl>): Provider {
  return {
    provide: GalleryIntl,
    useClass: intl,
  }
}

@Injectable({providedIn: 'root'})
export class GalleryIntl {

  public readonly changes$ = new Subject<void>();

  public previousPageButtonLabel = 'Previous page';

  public nextPageButtonLabel = 'Next page';

}
